module.exports = __webpack_public_path__ + "static/media/48382669_2308753255866519_5967071529748398080_o-thumb.cb235671.jpg";